// Libraries
import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

// Components
// import Component from '~/components/componentName';

/**********
 ** Component: IconCheck
 ** @type: functional stateless component
 ** @description:  componentDescription
 **********/
const IconCheck = props => {
	let completedFill = '#EBECEF';
	let title = 'The goal is yet to be achieved.';
	if (props.completed) {
		completedFill = '#00d300';
		title = 'The goal was achieved!';
	}
	return (
		<Figure style={props.style} className="icon" title={`${title}`}>
			<svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 16 16">
				<circle cx="8" cy="8" r="8" fill={`${props.color || completedFill}`} />
				<path
					fill={props.checkColor || '#fff'}
					d="M7.29 8.49c-.47-.43-.85-.75-1.2-1.12s-.62-.44-1-.08a.72.72 0 0 0 0 1v.06c.57.77 1.15 1.55 1.68 2.34.38.54.67.56 1 0 1-1.52 2-3 3.05-4.56.26-.39.43-.73 0-1.12s-.69-.06-.94.26L7.33 8.51"
				/>
			</svg>
		</Figure>
	);
};

const Figure = styled.figure`
	display: flex;
	width: ${rem('16px')};
	height: ${rem('16px')};
`;

export default IconCheck;



// WEBPACK FOOTER //
// ./src/components/ui/layout/icons/icon-check.jsx